module.exports = __webpack_public_path__ + "static/img/h9-1.abb942a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h9-1.png
// module id = EGtA
// module chunks = 1